import ApiDOMError from "./ApiDOMError.mjs";
/**
 * @public
 */
class UnsupportedOperationError extends ApiDOMError {}
export default UnsupportedOperationError;